import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import FullLoading from "../../../../components/full-loading3";
import { getUserInfo, unbindCard } from "../../api";
import "./index.less";
import PopupModelCenter, {
  PopupModelProps
} from "../../../../components/popup-model-center";
import { encryptBankCardNo } from "../../utils";
import ContactService from "../../../../components/contact-service";
import Toast from "@xpeng/rc-toast";
import { trackGdp } from "../../../../utils/gio-report";
const ManageCard = () => {
  const router = useHistory();
  const [bankAccount, setBankAccount] = useState("");
  const [visible, setVisible] = useState(false);
  const [popupModelData, setPopupModelData] = useState<PopupModelProps>({});
  useEffect(() => {
    document.title = "银行卡管理";
    trackGdp('P20146', 'B001')
    getUserInfo({}).then(res => {
      if (
        [0, 200].includes(res.code) &&
        res.data?.userCardRelaDto?.bankAccount
      ) {
        setBankAccount(encryptBankCardNo(res.data.userCardRelaDto.bankAccount));
      }
    });
  }, []);

  // 绑卡失败
  const changeCard = () => {
    trackGdp('P20146', 'B002')
    setVisible(true);
    setPopupModelData({
      popupTitle: "更换银行卡",
      content: (
        <div>更换银行卡需先解绑当前银行卡再绑定新银行卡，是否确认解绑？</div>
      ),
      leftBtnText: "不解绑",
      leftBtnFun: () => {
        setVisible(false);
      },
      rightBtnText: "确认解绑",
      rightBtnFun: () => {
        setVisible(false);
        FullLoading.show({
          text: "请稍后"
        });
        toUnBindCard()
          .then(res => {
            if (res) {
              FullLoading.hide();
              Toast.show('解绑成功');
              router.replace('/bind-card');
            }
          })
          .finally(() => {
            FullLoading.hide();
          });
      }
    });
  };

  // 解绑
  const unBind = () => {
    trackGdp('P20146', 'B003')
    setVisible(true);
    setPopupModelData({
      popupTitle: "确认解绑",
      content: (
        <div>
          解绑后，共享订单产生的收益将无法提现。若要提现需再次进行绑定操作，是否确认解绑？
        </div>
      ),
      leftBtnText: "确认解绑",
      leftBtnFun: () => {
        setVisible(false);
        FullLoading.show({
          text: "请稍后"
        });
        toUnBindCard()
          .then(res => {
            if (res) {
              FullLoading.hide();
              Toast.show('解绑成功');
              router.replace('/income');
            }
          })
          .finally(() => {
            FullLoading.hide();
          });
      },
      rightBtnText: "不解绑",
      rightBtnFun: () => {
        setVisible(false);
      }
    });
  };

  // 解绑失败
  const unBindFail = (res) => {
    const failMsg = res?.msg || "";
    trackGdp('P20146', 'B004')
    setVisible(true);
    setPopupModelData({
      popupTitle: "解绑失败",
      content: (
        <div>
          很抱歉，解绑失败了
          <br />
          失败原因：{failMsg}
        </div>
      ),
      leftBtnText: <ContactService><div style={{color: 'rgba(0, 0, 0, 0.9)'}}>咨询客服</div></ContactService>,
      leftBtnFun: () => {
        setVisible(false);
      },
      rightBtnText: "好的",
      rightBtnFun: () => {
        setVisible(false);
      }
    });
  };

  const toUnBindCard = () => {
    return new Promise((resolve, rej) => {
      unbindCard({}).then(res => {
        if ([0, 200].includes(res.code)) {
          resolve(true);
        } else {
          unBindFail(res);
          FullLoading.hide();
        }
      });
    });
  };
  return (
    <div className="manage-card-content">
      <div className="img-content">
        <img
          src="https://s.xiaopeng.com/xp-charge/charge/static/manage-card-bg.png"
          alt=""
        />
        <div className="card-num">{bankAccount}</div>
      </div>
      <div>
        <div className="btn-item">
          <div className="btn" onClick={changeCard}>
            更换银行卡
          </div>
          <div className="btn-text" onClick={unBind}>
            解绑
          </div>
        </div>
      </div>

      <PopupModelCenter
        visible={visible}
        popupTitle={popupModelData.popupTitle}
        content={popupModelData.content}
        leftBtnText={popupModelData.leftBtnText}
        rightBtnText={popupModelData.rightBtnText}
        leftBtnFun={popupModelData.leftBtnFun}
        rightBtnFun={popupModelData.rightBtnFun}
      />
    </div>
  );
};
export default ManageCard;
